export const texts = {
  decideCta: {
    de: 'Jetzt entscheiden',
    en: 'Decide now'
  },
  decide: {
    de: 'Wie soll es mit der Bewerbung weitergehen?',
    en: 'How should this application proceed?'
  },
  statusCta: {
    de: 'Status aktualisieren',
    en: 'Update status'
  },
  status: {
    de: 'Wie ist der Status der Bewerbung?',
    en: 'What is the status of the application?'
  },
  feedbackCta: {
    de: 'Jetzt abgeben',
    en: 'Submit now'
  },
  feedback: {
    de: 'Ihr Feedback zur Bewerbung wurde angefragt!',
    en: 'Your feedback on the application has been requested!'
  }
};
